import React from "react";

import { useSearchParams } from "utils";

import { LoginStep } from "pages/app/soilsight-pre-login/components/steps/LoginStep";
import { SignupStep } from "pages/app/soilsight-pre-login/components/steps/SignupStep";
import { trackSoilSightLoginClick } from "pages/app/soilsight-pre-login/utils/acquisitionTracking";

// One step, two forms — mirrors the real /sign-up and /sign-in pages, which each show one form plus a
// button to the other. Mode lives in the URL (?mode=login) rather than local state, so SoilSightFlowOverlay
// — which only sees the route, not this component's state — can show the right title and back behaviour too.
export const SignupOrLoginStep = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  if (searchParams.get("mode") === "login") {
    return (
      <LoginStep
        onSignupClick={() => {
          const next = new URLSearchParams(searchParams);
          next.delete("mode");
          setSearchParams(next);
        }}
      />
    );
  }

  return (
    <SignupStep
      onLoginClick={() => {
        trackSoilSightLoginClick();
        const next = new URLSearchParams(searchParams);
        next.set("mode", "login");
        setSearchParams(next);
      }}
    />
  );
};
